import { Field, useField, useFormikContext } from "formik";
import { useCallback, useMemo } from "react";
import HelpOrErrorMessage from "./HelpOrErrorMessage";

export function FormField({ label, help, before, after, className, submitOnChange, ...props }) {
    const { submitForm, isSubmitting } = useFormikContext();
    const [field, meta, helpers] = useField(props);

    const errorClass = meta.error && meta.touched ? "error" : undefined;

    const fieldClass = [className, errorClass].filter(Boolean).join(" ");

    const handleBlur = useCallback(
        event => {
            if (submitOnChange) {
                field.onBlur(event);
                submitForm();
            } else {
                field.onBlur(event);
            }
        },
        [submitOnChange, submitForm, field]
    );

    return (
        <>
            <label htmlFor={props.name} className={errorClass}>
                {label}
            </label>
            <div>
                <div style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                    {before}
                    <Field
                        id={props.name}
                        onBlur={handleBlur}
                        className={fieldClass}
                        disabled={isSubmitting}
                        {...props}
                    />
                    {after}
                </div>
                <HelpOrErrorMessage name={props.name}>{help}</HelpOrErrorMessage>
            </div>
        </>
    );
}
